import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormatService } from '../services/format.service';
import { sEvent } from '../models/sevent.model';

@Injectable({
  providedIn: 'root',
})
export class EventSearchService {
  apiHost: string = environment.apiHost;
  public eventArr: sEvent[] = [];
  constructor(private http: HttpClient, private _format: FormatService) {}

  getEventsByDate(day: string, groupId: number, venue: string): Promise<sEvent[]> {
    let promise = new Promise<sEvent[]>((resolve, reject) => {
      return this.http
        .get<sEvent[]>(this.apiHost + '/event/geteventsByDate?Day=' + day + '&ServiceGroupId=' + groupId + '&Venue=' + venue)
        .toPromise()
        .then(
          (data) => {
            this.eventArr = data;
            resolve(this.eventArr);
          },
          (msg) => {
            this.eventArr = null;
            resolve(this.eventArr);
          }
        );
    });
    return promise;
  }

  getTodaysEvents(day: string): Promise<sEvent[]> {
    let promise = new Promise<sEvent[]>((resolve, reject) => {
      return this.http
        .get<sEvent[]>(this.apiHost + '/event/getTodaysEvents?Day=' + day)
        .toPromise()
        .then(
          (data) => {
            this.eventArr = data;
            resolve(this.eventArr);
          },
          (msg) => {
            this.eventArr = null;
            resolve(this.eventArr);
          }
        );
    });
    return promise;
  }
}
